var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23 20.5",
    enableBackground: "new 0 0 23 20.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,14.9l-2-8.8c0,0,0-0.1,0-0.1V4.3C21,1.9,19.1,0,16.7,0h-1.4c-1.6,0-3.1,0.9-3.8,2.3 C10.8,0.9,9.3,0,7.7,0H6.3C3.9,0,2,1.9,2,4.3V6c0,0,0,0.1,0,0.1l-2,8.8c0,0,0,0.1,0,0.1v3c0,0.3,0.2,0.5,0.5,0.5H1V20 c0,0.3,0.2,0.5,0.5,0.5S2,20.3,2,20v-1.5h19V20c0,0.3,0.2,0.5,0.5,0.5S22,20.3,22,20v-1.5h0.5c0.3,0,0.5-0.2,0.5-0.5v-3 C23,15,23,14.9,23,14.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23,14.9l-2-8.8c0,0,0-0.1,0-0.1V4.3C21,1.9,19.1,0,16.7,0h-1.4c-1.6,0-3.1,0.9-3.8,2.3 C10.8,0.9,9.3,0,7.7,0H6.3C3.9,0,2,1.9,2,4.3V6c0,0,0,0.1,0,0.1l-2,8.8c0,0,0,0.1,0,0.1v3c0,0.3,0.2,0.5,0.5,0.5H1V20 c0,0.3,0.2,0.5,0.5,0.5S2,20.3,2,20v-1.5h19V20c0,0.3,0.2,0.5,0.5,0.5S22,20.3,22,20v-1.5h0.5c0.3,0,0.5-0.2,0.5-0.5v-3 C23,15,23,14.9,23,14.9z M12,4.3C12,2.5,13.5,1,15.3,1h1.4C18.5,1,20,2.5,20,4.3v1.2h-8V4.3z M3,4.3C3,2.5,4.5,1,6.3,1h1.4 C9.5,1,11,2.5,11,4.3v1.2H3V4.3z M3,6.5h17.1l1.8,8H1.1L3,6.5z M22,17.5H1v-2h21V17.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureBed);
export default __webpack_public_path__ + "static/media/feature-bed.87f04b109b206fc8d7d0ac97fe9faa14.svg";
export { ForwardRef as ReactComponent };